<mat-card *ngIf="myProfileArr" class="profile-card glass-effect">
    <mat-card-header class="profile-header">
        <mat-icon (click)="returnToDashboard()" class="back-icon">arrow_back</mat-icon>
        <mat-card-title class="profile-title">Meus Dados</mat-card-title>
        <mat-card-subtitle class="profile-subtitle">Informações do seu perfil</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="profile-content">
        <div class="info-alert">
            <mat-icon class="alert-icon">info</mat-icon>
            <span>Qualquer alteração cadastral deve ser solicitada via telefone, e-mail ou presencialmente em uma de nossas unidades.</span>
        </div>

        <!-- Personal Information Section -->
        <div class="section">
            <h3 class="section-title">
                <mat-icon>person</mat-icon>
                Informações Pessoais
            </h3>
            <div class="fields-grid">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Nome/Razão Social</mat-label>
                    <input type="text" matInput [value]="myProfileArr.NOME" readonly>
                    <mat-icon matPrefix>badge</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Documento</mat-label>
                    <input type="text" matInput [value]="(myProfileArr.CODIGO_TIPO_PESSOA == 'F' ? myProfileArr.CPF : myProfileArr.CNPJ)" mask="000.000.000-00||00.000.000/0000-00" readonly>
                    <mat-icon matPrefix>{{ myProfileArr.CODIGO_TIPO_PESSOA == 'F' ? 'credit_card' : 'business' }}</mat-icon>
                </mat-form-field>
            </div>
        </div>

        <!-- Contact Information Section -->
        <div class="section">
            <h3 class="section-title">
                <mat-icon>contact_phone</mat-icon>
                Informações de Contato
            </h3>
            <div class="fields-grid">
                <mat-form-field appearance="outline" *ngIf="myProfileArr.TEL_CELULAR">
                    <mat-label>Celular</mat-label>
                    <input type="text" matInput [value]="myProfileArr.TEL_CELULAR" mask="(99) 99999-9999" readonly>
                    <mat-icon matPrefix>phone_android</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="myProfileArr.TEL_TRABALHO">
                    <mat-label>Telefone Trabalho</mat-label>
                    <input type="text" matInput [value]="myProfileArr.TEL_TRABALHO" mask="(99) 99999-9999" readonly>
                    <mat-icon matPrefix>work</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="myProfileArr.TEL_RESIDENCIAL">
                    <mat-label>Telefone Residencial</mat-label>
                    <input type="text" matInput [value]="myProfileArr.TEL_RESIDENCIAL" mask="(99) 99999-9999" readonly>
                    <mat-icon matPrefix>home</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="myProfileArr.TEL_OUTROS">
                    <mat-label>Outro Telefone</mat-label>
                    <input type="text" matInput [value]="myProfileArr.TEL_OUTROS" mask="(99) 99999-9999" readonly>
                    <mat-icon matPrefix>phone</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>E-mail</mat-label>
                    <input type="text" matInput [value]="myProfileArr.EMAIL" readonly>
                    <mat-icon matPrefix>email</mat-icon>
                </mat-form-field>
            </div>
        </div>

        <!-- Address Information Section -->
        <div class="section">
            <h3 class="section-title">
                <mat-icon>location_on</mat-icon>
                Endereço
            </h3>
            <div class="fields-grid">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Logradouro</mat-label>
                    <input type="text" matInput [value]="myProfileArr.LOGRADOURO + ', ' + myProfileArr.NUMERO + (myProfileArr.COMPLEMENTO ? ', ' + myProfileArr.COMPLEMENTO : '')" readonly>
                    <mat-icon matPrefix>place</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Bairro</mat-label>
                    <input type="text" matInput [value]="myProfileArr.BAIRRO" readonly>
                    <mat-icon matPrefix>map</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Cidade/UF</mat-label>
                    <input type="text" matInput [value]="myProfileArr.CIDADE + ' - ' + myProfileArr.UF" readonly>
                    <mat-icon matPrefix>location_city</mat-icon>
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
</mat-card>
